"use client";

import { ListMusic } from "lucide-react";
import { SidebarMenuButton, SidebarMenuItem } from "@src/components/ui/sidebar";
import { useGetPlaylistsByUserId } from "@src/queries/getPlaylistsByUserId";
import { paths } from "@src/utils";
import { usePathname } from "next/navigation";
import { SidebarLink } from "./SidebarLink";
export const PlaylistsNav = ({
  userId
}: {
  userId: string;
}) => {
  const {
    data: playlists
  } = useGetPlaylistsByUserId(userId);
  const pathname = usePathname();
  if (playlists.length === 0) {
    return <div className="px-2 py-2 text-sm text-muted-foreground">
        No playlists found
      </div>;
  }
  return <>
      {playlists.map(playlist => <SidebarMenuItem key={playlist.id}>
          <SidebarMenuButton asChild isActive={pathname.startsWith(`/playlist/${playlist.id}`)}>
            <SidebarLink href={paths.playlist(playlist.id)}>
              <ListMusic className="h-4 w-4" />
              <span>{playlist.name}</span>
            </SidebarLink>
          </SidebarMenuButton>
        </SidebarMenuItem>)}
    </>;
};